// extracted by mini-css-extract-plugin
export default {"btn":"MainBtn_btn__A5WiD","btn__right":"MainBtn_btn__right__jTeT+","btn__smallCircle":"MainBtn_btn__smallCircle__UPevF","btn__bigCircle":"MainBtn_btn__bigCircle__+HhEM"};